<template>
  <div class="filter">
    <div class="list-table">
      <div class="title-font">
        事件名称:<span style="margin-right: 20px;">{{eventname}}</span>
        事件总数:<span>{{eventCount}}</span>
      </div>
      <el-table  :data="reportList" class="tableList">
        <el-table-column
          prop="eventTime"
          align="center"
          label="告警时间"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="eventValue"
          align="center"
          label="告警值"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
    </div>
    <div style="float: right; margin-right: 10px; margin-top: 10px">
      <el-pagination
        @current-change="pageChange"
        background
        :current-page="page"
        :page-size="sizePage"
        layout="total,prev, pager, next, jumper"
        :total="totalSum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Axios from "../../utils/Axios";

export default {
  name: "fFilter",
  props: {
    eventid:'',
    eventCount:'',
    eventname:'',
  },
  data() {
    return {
      page: 1,
      sizePage: 10,
      totalSum: 0,
      loading: true,
      reportList:[]
    };
  },
  methods: {
    // 当前页数
    pageChange(val) {
      this.page = val;
      this.queryTableList()
    },
    queryTableList() {
      this.loading = true;
      this.reportList = [];

      const params = {
        url: "/event/eventPage",
        method: "post",
        data: {
          "id": this.eventid,
          pageNum:  this.page,
          showNum: this.sizePage,
        },
      };
      Axios.ajax(params).then((res) => {
        if (res.data) {
          this.loading = false;
          this.reportList = res.data.dataList;
          this.totalSum = res.data.totalNum;
        }
      });
    },
  },
  created() {

  },
  mounted() {
    console.log(this.eventid)
    this.queryTableList()
  },
  watch:{
    eventid(){
      this.queryTableList()
    }
  }
};
</script>

<style lang="less" scoped>
.filter {
  padding-bottom: 30px;

}
.list-table{

  height: 590px;
}
.title-font{
  font-size: 14px;
  color: #252b3c;
  margin-bottom: 20px;
}
</style>
